import Auth from '../services/Auth';
import Database from './Database';
import validarTipo from '../utils/validarTipo';

import cadastroJogadores from '../constants/jogadores';
import indicacoes from '../constants/indicacoes';
import objToArray from '../utils/objToArray';
import { env } from '../constants';

/**
 * Campeonato
 *
 * @export
 * @class Campeonato
 */
export default class Campeonato {
  static semFoto = [];

  /**
   * isAcompanhamentoDisponivel
   *
   * @static
   * @returns boolean
   * @memberof Campeonato
   */
  static async isAcompanhamentoDisponivel() {
    try {
      const acompanhamentoDisponivel = await Database.recuperar(`acompanhamento`);
      return acompanhamentoDisponivel && true;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  /**
   * isAdministrador
   *
   * @static
   * @returns boolean
   * @memberof Campeonato
   */
  static async isAdministrador() {
    try {
      const admins = await Database.recuperar(`administradores`);
      const user = Auth.getUsuario().uid;
      const admin = admins.filter(item => item === user);
      return admin.length > 0 || false;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  /**
   * isEscolhaLivre
   *
   * @static
   * @returns boolean
   * @memberof Campeonato
   */
  static async isEscolhaLivre() {
    try {
      const escolha = await Database.recuperar(`escolhaLivre`);
      return escolha === true || false;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  /**
   * consultarTitulo
   *
   * @static
   * @param {*} campeonato
   * @returns
   * @memberof Campeonato
   */
  static async consultarTitulo(campeonato) {
    if (!validarTipo(campeonato, 'string')) {
      return '';
    }

    try {
      const tituloCampeonato = await Database.recuperar(`campeonatos/${campeonato}/nome`);
      return tituloCampeonato;
    } catch (e) {
      console.log(e);
      return '';
    }
  }

  /**
   * listarTimes
   *
   * @static
   * @param {*} campeonato
   * @returns
   * @memberof Campeonato
   */
  static async listarTimesPorCampeonato(campeonato) {
    if (!validarTipo(campeonato, 'string')) {
      return [];
    }

    try {
      const times = [];
      const filtro = [];
      const timesCampeonato = await Database.recuperar(`campeonatos/${campeonato}/times`);
      const base = await Database.recuperar('times');
      base.map((item, index) => {
        if (timesCampeonato.includes(index)) {
          const time = { id: index, ...item };
          filtro.push(time);
        }
        return null;
      });
      const promiseBase = filtro.map(async item => {
        const time = { ...item, jogadores: await Campeonato.listarJogadoresSelecaoPorTime(campeonato, item.id) };
        return time;
      });
      for (const time of promiseBase) {
        times.push(await time);
      }
      return times;
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  /**
   * listarJogadoresPorSelecao
   *
   * @static
   * @param {*} campeonato
   * @param {*} idTimeCampeonato
   * @returns
   * @memberof Campeonato
   */
  static async listarJogadoresSelecaoPorTime(campeonato, idTimeCampeonato) {
    if (!validarTipo(campeonato, 'string') || !validarTipo(idTimeCampeonato, 'number')) {
      return [];
    }
    try {
      const grupos = [];
      const jogadores = [];
      const timesSelecao = await Database.recuperar(`campeonatos/${campeonato}/selecao/${idTimeCampeonato}/jogadores`);
      if (!timesSelecao) {
        return [];
      }
      // if (idTimeCampeonato === 2) console.log('timeSelecao', timesSelecao);
      const gruposCampeonato = await Campeonato.listarGruposPorCampeonato(campeonato);
      if (idTimeCampeonato === 2) console.log('gruposCampeonato', gruposCampeonato);

      const promiseGrupo = gruposCampeonato.length > 0 ? gruposCampeonato.map(async grupo => await Campeonato.listarJogadoresPorGrupo(grupo)) : [];
      for (const grupo of promiseGrupo) {
        grupos.push(...(await grupo));
      }
      // if (idTimeCampeonato === 2) console.log('grupos', grupos);
      const promiseBase = timesSelecao.map(async item => {
        const jogador = await Database.recuperar(`jogadores/${item}`);
        if (!jogador) console.log('item', item);
        jogador.id = item;
        return jogador;
      });
      for (const jogador of promiseBase) {
        jogadores.push(await jogador);
        // if (idTimeCampeonato === 2) console.log('jogador', await jogador);
      }
      const jogadoresComGrupo = jogadores.map(jogador => {
        const grupo = grupos.filter(grupo => grupo.id === jogador.id);
        // if (idTimeCampeonato === 2) console.log('jogadorComGrupo', grupo);
        return { idGrupo: grupo[0].idGrupo, ...jogador };
      });
      return jogadoresComGrupo;
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  /**
   * listarIdsJogadoresSelecaoPorCampeonato
   *
   * @static
   * @param {*} campeonato
   * @memberof Campeonato
   */
  static async listarIdsJogadoresSelecaoPorCampeonato(campeonato) {
    if (!validarTipo(campeonato, 'string')) {
      return [];
    }
    try {
      const jogadores = [];
      const selecao = await Database.recuperar(`campeonatos/${campeonato}/selecao`);
      if (Array.isArray(selecao)) {
        for (const time of selecao) {
          if (time) {
            jogadores.push(...time.jogadores);
          }
        }
      } else if (validarTipo(selecao, 'object')) {
        for (const time in selecao) {
          if (selecao.hasOwnProperty(time)) {
            jogadores.push(...selecao[time].jogadores);
          }
        }
      }
      return jogadores;
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  /**
   * listarJogadoresPorGrupo
   *
   * @static
   * @param {number} grupo
   * @memberof Jogador
   */
  static async listarJogadoresPorGrupo(grupo) {
    if (!validarTipo(grupo, 'number')) {
      return [];
    }

    try {
      const jogadores = [];
      const infoGrupo = await Database.recuperar(`grupos/${grupo}`);
      const grupoCampeonato = infoGrupo.jogadores || [];
      const promiseBase = grupoCampeonato.map(async item => {
        const jogador = await Database.recuperar(`jogadores/${item}`);
        jogador.id = item;
        return jogador;
      });
      for (const jogador of promiseBase) {
        jogadores.push({ idGrupo: grupo, nomeGrupo: infoGrupo.nome, ...(await jogador) });
      }
      return jogadores;
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  /**
   * listarGruposPorCampeonato
   *
   * @static
   * @param {*} campeonato
   * @returns
   * @memberof Campeonato
   */
  static async listarGruposPorCampeonato(campeonato) {
    if (!validarTipo(campeonato, 'string')) {
      return [];
    }

    try {
      const grupos = await Database.recuperar(`campeonatos/${campeonato}/grupos`);
      return grupos;
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  /**
   * selecionarJogador
   *
   * @static
   * @param {*} campeonato
   * @param {*} idTime
   * @param {*} jogador
   * @returns
   * @memberof Campeonato
   */
  static async selecionarJogador(campeonato, idTime, jogador) {
    if (!validarTipo(campeonato, 'string') || !validarTipo(idTime, 'number') || !validarTipo(jogador, 'object')) {
      console.log('não escolheu');
      return false;
    }
    try {
      const selecao = await Database.recuperar(`campeonatos/${campeonato}/selecao/${idTime}/jogadores`);
      if (selecao) {
        selecao.push(jogador.id);
      }
      const novaSelecao = selecao ? selecao : [jogador.id];
      await Database.gravar(`campeonatos/${campeonato}/selecao/${idTime}/jogadores`, novaSelecao);
      const registro = { tipo: 'selecionar', idTime, jogador };
      await Database.gravar(`campeonatos/${campeonato}/ultimaAcao`, registro);
      return true;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  /**
   * removerJogador
   *
   * @static
   * @param {*} campeonato
   * @param {*} idTime
   * @param {*} jogador
   * @returns
   * @memberof Campeonato
   */
  static async removerJogador(campeonato, idTime, jogador) {
    if (!validarTipo(campeonato, 'string') || !validarTipo(idTime, 'number') || !validarTipo(jogador, 'object')) {
      return false;
    }
    try {
      const selecao = await Database.recuperar(`campeonatos/${campeonato}/selecao/${idTime}/jogadores`);
      const novaSelecao = selecao.filter(jog => jog !== jogador.id);
      await Database.gravar(`campeonatos/${campeonato}/selecao/${idTime}/jogadores`, novaSelecao);
      const registro = { tipo: 'remover', idTime, jogador };
      await Database.gravar(`campeonatos/${campeonato}/ultimaAcao`, registro);
      return true;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  /**
   * onAlteracaoJogador
   *
   * @static
   * @param {*} campeonato
   * @param {*} callback
   * @memberof Campeonato
   */
  static onAlteracaoJogador(campeonato, callback) {
    if (!validarTipo(campeonato, 'string') || !validarTipo(callback, 'function')) {
      return false;
    }
    try {
      Database.listener(`campeonatos/${campeonato}/ultimaAcao`, callback);
      return true;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  static onAtualizacao(callback) {
    if (!validarTipo(callback, 'function')) {
      return false;
    }
    try {
      Database.listener(`atualizar`, callback);
      return true;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  static async listarJogadores() {
    try {
      const jogadores = await Database.recuperar(`jogadores`);
      const jogadoresArray = objToArray(jogadores);
      // console.log('jogArray', jogadoresArray);
      return jogadoresArray;
    } catch (e) {
      return {};
    }
  }

  static async cadastrarJogadores(campeonato) {
    try {
      const jogadores = await Database.recuperar('jogadores');
      const qtdeRecuperada = `${Object.keys(jogadores).length}`;
      console.log('jogadores - recuperados: ', parseInt(qtdeRecuperada, 10));

      /** IMPORTANTE - alterar o prefixo para o campeonato desejado no arquivo env.js */
      const PREFIXO = env.PREFIX_JOGADORES;
      
      cadastroJogadores.map(jog => {
        if (!jogadores[`${PREFIXO}${jog.id.toString()}`]) {
          jogadores[`${PREFIXO}${jog.id.toString()}`] = {
            id: jog.id.toString(),
            nome: jog.nome,
            nomeCompleto: jog.nomeCompleto,
            dataNasc: jog.dataNasc,
            categoria: jog.categoria,
            foto: jog.foto,
          };
        }
        return null;
      });
      const qtdeTotal = `${Object.keys(jogadores).length}`;
      console.log('jogadores - novos:', parseInt(qtdeTotal,10) - parseInt(qtdeRecuperada, 10));
      console.log('jogadores - novo total:', parseInt(qtdeTotal, 10));

      const grupos = await Database.recuperar('grupos') || [];
      const qtdeAtualGrupos = grupos.length - 1;
      cadastroJogadores.map(jogador => {
        if (!grupos[jogador.grupo + qtdeAtualGrupos]) {
          grupos[jogador.grupo + qtdeAtualGrupos] = { nome: jogador.grupo, jogadores: [`${PREFIXO}${jogador.id.toString()}`] };
        } else {
          if (!grupos[jogador.grupo + qtdeAtualGrupos].jogadores) {
            grupos[jogador.grupo + qtdeAtualGrupos].jogadores = [`${PREFIXO}${jogador.id.toString()}`];
          } else {
            grupos[jogador.grupo + qtdeAtualGrupos].jogadores.push(`${PREFIXO}${jogador.id.toString()}`);
          }
        }
        return null;
      });

      const gruposCampeonato = await Database.recuperar(`campeonatos/${campeonato}/grupos`) || [];
      console.log('grupos', grupos);
      grupos.map((grupo, index) => {
        if (!gruposCampeonato.includes(index) && index >  qtdeAtualGrupos) {
          gruposCampeonato.push(index);
        }
        return null;
      });
      /** NÃO ESQUECER DE ALTERAR O PREFIXO NO INÍCIO DO BLOCO */
      gruposCampeonato.sort((a, b) => a - b);
      // await Database.gravar('jogadores', jogadores); // Substitui caso não existam
      // await Database.gravar('grupos', grupos); // Sempre serão adicionados novos grupos na sequencia. Atenção
      // await Database.gravar(`campeonatos/${campeonato}/grupos`, gruposCampeonato); // Deveria gravar
      // await Database.gravar(`campeonatos/${campeonato}/selecao`, indicacoes);
      console.log(`${Object.keys(jogadores).length} jogadores incluídos em ${gruposCampeonato.length} grupos`);
      console.log(`${Object.keys(grupos).length} grupos.`);
      return true;
    } catch (e) {
      console.log('erro', e);
      return false;
    }
  }
}
